import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { TermsDialog } from "@/features/terms/TermsDialog";
import terms from "./terms.md?raw";
import { computeVersion } from "./computeVersion";

export function TermsConsentGate() {
	const { user, profile } = useAuth();
	const [open, setOpen] = useState(false);
	const [content, setContent] = useState<string | null>(null);
	const [version, setVersion] = useState<string | null>(null);

	useEffect(() => {
		async function check() {
			try {
				if (!profile) {
					return;
				}
				const v = await computeVersion(terms);
				const accepted = Boolean(profile.tnc_accepted);
				const acceptedVersion = String(profile.tnc_version || "");
				const shouldOpen = !accepted || acceptedVersion !== v;
				if (shouldOpen) {
					setContent(terms);
					setVersion(v);
					setOpen(shouldOpen);
				} else {
					setOpen(false);
				}
			} catch (e: any) {
				console.error("Error checking terms", e);
				// Network/crypto issues: show dialog to be safe
				setOpen(true);
			}
		}
		check();
		// Also re-check when user/profile changes
	}, [user, profile?.tnc_accepted, profile?.tnc_version]);

	if (!user || !content || !version) {
		return null;
	}
	return (
		<TermsDialog
			open={open}
			onOpenChange={setOpen}
			mode="consent"
			content={content}
			version={version}
			onAccepted={() => setOpen(false)}
		/>
	);
}
